
import eventTrackingMixins from '~/mixins/eventTrackingMixins.js';
export default {
  name: "HappyKidsPromotionBannerSection",
  mixins: [eventTrackingMixins],
  props: {
    data: {
      type: Object,
      default: () => {}
    },
    containerClass: {
      type: String,
      default: '',
    }
  },
  computed: {
    getContainerClass() {
      return this.containerClass;
    }
  },
  methods: {
    /**
     * @return {string[]}
     * @description set section style based on data from CMS.
     */
     sectionStyle(layoutStyle) {
      if ( !layoutStyle ) return;

      const style = []
      if (layoutStyle?.BackgroundColorHex) {
          style.push({'background-color': layoutStyle?.BackgroundColorHex})
      }
      if (layoutStyle?.DisableMinHeight) {
          style.push({'min-height': 'auto'})
      }
      if (layoutStyle?.PaddingTopInPx && layoutStyle?.PaddingTopInPx >= 0 ) {
          style.push({'padding-top': `${layoutStyle?.PaddingTopInPx}px`})
      }
      if (layoutStyle?.PaddingBottomInPx && layoutStyle?.PaddingBottomInPx >= 0 ) {
          style.push({'padding-bottom': `${layoutStyle?.PaddingBottomInPx}px`})
      }
      return style
    },
  }
}
